import { render, staticRenderFns } from "./modal-orders-modify-tracking-number.vue?vue&type=template&id=422e144c&scoped=true&lang=pug"
import script from "./modal-orders-modify-tracking-number.js?vue&type=script&lang=js&external"
export * from "./modal-orders-modify-tracking-number.js?vue&type=script&lang=js&external"
import style0 from "./modal-orders-modify-tracking-number.vue?vue&type=style&index=0&id=422e144c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e144c",
  null
  
)

export default component.exports